module.exports = __webpack_public_path__ + "static/media/emailIcon.f5da1dc6.svg";